import React from 'react';
import {
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	makeStyles,
	SvgIcon,
	Typography,
} from '@material-ui/core';
import { useHistory, useParams } from 'react-router';
import layoutService from 'src/services/layoutService';
import DetailItem from '../components/detailItem';
import { AlertTriangle as AlertTriangleIcon } from 'react-feather';

const useStyles = makeStyles(theme => ({
	container: {
		paddingBottom: `${theme.spacing(1)}px !important`,

		'& div:last-child': {
			borderBottom: 0
		}
	},
	alertIcon: {
		color: theme.palette.error.main,
		fontSize: 36
	}
}));

function CadastralSection({ contractLine, ...rest }) {
	const classes = useStyles();
	const history = useHistory();
	const { contractLineId } = useParams();
	const entity = contractLine?.supplyLocation;

	function handleEdit() {
		if(layoutService.isMobile())
			history.push('/mobile/supply/contract/edit/cadastral', { contractLine });
		else 
			history.push(`/app/supply/${contractLineId}/contract/edit/cadastral`, { entity, contractLine })
	}

	return (
		<Card {...rest}>
			<CardHeader title="Dati Catastali" />
			<CardContent className={classes.container}>
				{entity?.cadastalMissingData ? (
					<Box mb={2} textAlign="center">
						<SvgIcon className={classes.alertIcon}>
							<AlertTriangleIcon />
						</SvgIcon>
						<Typography variant="subtitle2" color="error" align="center">
							{entity?.cadastalMissingData?.name}
						</Typography>
					</Box>
				) : (
					<>
						<DetailItem
							title="Tipo unità immobiliare"
							value={entity?.cadastalUnitType?.name}
						/>
						<DetailItem
							title="Qualifica titolare"
							value={entity?.cadastalHolder?.name}
						/>
						<DetailItem title="Sezione" value={entity?.cadastalSection} />
						<DetailItem
							title="Foglio"
							value={entity?.cadastalSheet}
						/>
						<DetailItem
							title="N° Particella"
							value={entity?.cadastalParticle}
						/>
						<DetailItem title="Subalterno" value={entity?.cadastalSubordinate} />
						<DetailItem
							title="Tipo particella"
							value={entity?.cadastalParticleType?.name}
						/>
						<DetailItem
							title="Estensione particella"
							value={entity?.cadastalParticleExtension}
						/>
					</>
				)}
				<Box mt={3} mb={1}>
					<Button
						fullWidth
						variant="contained"
						color="secondary"
						onClick={handleEdit}
					>
						Modifica
					</Button>
				</Box>
			</CardContent>
		</Card>
	);
}

export default CadastralSection;
